<template>
    <div class="md:text-sm">
        <div class="flex ">
            <button class="bg-blue-100 p-3 rounded-xl ml-3">Suspend</button>
            <div class="p-2 rounded-xl ml-3 bg-blue-100 ">
                <i class="fa fa-commenting-o mr-2"></i>
                <router-link :to="{name: 'email-center'}">Message</router-link>
            </div>
        </div>
        <div class="mt-8">
            <div class="flex">
                <i class="fa fa-user text-blue-700"></i>
                <p class="ml-3 text-blue-700">Profile Details</p>
            </div>
            <hr>
        </div>
        <div class="mt-10">
            <div>
                <div class="flex mt-3">
                    <p class="w-1/3">Name</p>
                    <p class="w-1/3 text-blue-700">Michael Wingate</p>
                </div>
                <div class="flex mt-3">
                    <p class="w-1/3">Email</p>
                    <p class="w-1/3 text-blue-700">michaelwingate@gmail.com</p>
                </div>
                <div class="flex mt-3">
                    <p class="w-1/3">Phone Number</p>
                    <p class="w-1/3 text-blue-700">+23485785733</p>
                </div>
                <div class="flex mt-3">
                    <p class="w-1/3">Date Joined</p>
                    <p class="w-1/3 text-blue-700">15/12/2021</p>
                </div>
                <div class="flex mt-3">
                    <p class="w-1/3">Privileges</p>
                    <p class="w-1/3 text-blue-700">Dashboard, Users, DSOs, Manage Admin</p>
                </div>
            </div>
        </div>
    </div>
</template>